import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class ForceLoginUserFlow extends BaseUserFlow {
  protected readonly type = UserFlowType.ForceLogin;
  protected readonly canCancel = false;

  /**
   * @inheritdoc
   */
  public canChangeStep(step: string): boolean {
    return false;
  }

  /**
   * @inheritdoc
   */
  public setNextStep() {
    return super.setNextStep();
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();

    return [`${UserFlowType.Auth}.${UserFlowStep.Login}`];
  }
}
